import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      data-name="Component 39 \u2013 1"
      xmlns="http://www.w3.org/2000/svg"
      width={38}
      height={40.5}
      viewBox="0 0 38 40.5"
      {...props}
    >
      <text
        data-name="25000h"
        transform="translate(19 10)"
        fill="#fff"
        fontSize={11}
        fontFamily="Arial-BoldMT, Arial"
        fontWeight={700}
      >
        <tspan x={18.654} y={0}>
          {"25000h"}
        </tspan>
      </text>
      <g fill="#fff">
        <path
          data-name="Path 7459"
          d="M28.475 17.431A13.514 13.514 0 009.364 36.542a13.514 13.514 0 0019.111-19.111zm-.6 18.514A12.669 12.669 0 019.961 18.028a12.67 12.67 0 0117.917 17.917z"
        />
        <path
          data-name="Path 7460"
          d="M7.94 26.986a10.982 10.982 0 0117.08-9.131.422.422 0 00.47-.7 11.825 11.825 0 00-15.384 17.714.422.422 0 00.629-.563 10.961 10.961 0 01-2.795-7.32z"
        />
        <path
          data-name="Path 7461"
          d="M28.753 20.417a.422.422 0 10-.7.47 10.981 10.981 0 01-16.045 14.63.422.422 0 00-.532.656 11.826 11.826 0 0017.279-15.756z"
        />
        <path
          data-name="Path 7462"
          d="M26.239 18.802a11.082 11.082 0 01.814.808.422.422 0 10.625-.568 11.928 11.928 0 00-.876-.87.422.422 0 00-.563.629z"
        />
        <path
          data-name="Path 7463"
          d="M18.919 18.963a.422.422 0 00.422-.422v-1.268a.422.422 0 10-.845 0v1.267a.422.422 0 00.423.423z"
        />
        <path
          data-name="Path 7464"
          d="M18.497 35.433V36.7a.422.422 0 10.845 0v-1.267a.422.422 0 10-.845 0z"
        />
        <path
          data-name="Path 7465"
          d="M10.896 26.986a.422.422 0 00-.422-.422H9.206a.422.422 0 000 .845h1.267a.422.422 0 00.423-.423z"
        />
        <path
          data-name="Path 7466"
          d="M26.943 26.986a.422.422 0 00.422.422h1.267a.422.422 0 000-.845h-1.267a.422.422 0 00-.422.423z"
        />
        <path
          data-name="Path 7467"
          d="M15.062 19.461l-.633-1.1a.422.422 0 00-.731.422l.633 1.1a.422.422 0 10.731-.422z"
        />
        <path
          data-name="Path 7468"
          d="M23.508 34.09a.422.422 0 10-.731.422l.633 1.1a.422.422 0 10.731-.422z"
        />
        <path
          data-name="Path 7469"
          d="M10.509 32.265a.421.421 0 00.211-.057l1.1-.633a.422.422 0 00-.422-.731l-1.1.633a.422.422 0 00.212.788z"
        />
        <path
          data-name="Path 7470"
          d="M26.235 23.186a.42.42 0 00.211-.057l1.1-.633a.422.422 0 10-.422-.731l-1.1.633a.422.422 0 00.212.788z"
        />
        <path
          data-name="Path 7471"
          d="M23.987 18.209a.422.422 0 00-.577.155l-.633 1.1a.422.422 0 10.731.422l.633-1.1a.422.422 0 00-.154-.577z"
        />
        <path
          data-name="Path 7472"
          d="M14.908 33.936a.422.422 0 00-.577.155l-.633 1.1a.422.422 0 10.731.422l.633-1.1a.422.422 0 00-.154-.577z"
        />
        <path
          data-name="Path 7473"
          d="M26.023 31.576l1.1.633a.422.422 0 00.422-.731l-1.1-.633a.422.422 0 00-.422.731z"
        />
        <path
          data-name="Path 7474"
          d="M11.817 22.398l-1.1-.633a.422.422 0 00-.422.731l1.1.633a.422.422 0 10.422-.731z"
        />
        <path
          data-name="Path 7475"
          d="M21.86 32.5a.422.422 0 00.365-.633l-2.343-4.06a1.265 1.265 0 00-.54-2.017v-5.563a.422.422 0 00-.845 0v5.563a1.267 1.267 0 00.654 2.44l2.342 4.057a.422.422 0 00.367.213zm-3.362-5.514a.422.422 0 11.422.422.423.423 0 01-.422-.422z"
        />
      </g>
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
